// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  
.dashboard-container {
  display: flex;
  justify-content: space-between; 
  padding: 20px;
  border:2px solid rgb(184, 174, 174);
  margin-top:25px;

}


.left-table-container {
  display: flex;            
  flex-direction: column;   
  margin: 3px 8px 5px 20px;   

  border: 1px solid rgb(190, 185, 185);  
  padding: 20px; 
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);      
}

.left-table-container .button-container {
  display: flex;            
  flex-direction: row;      
  gap: 20px;                
  margin-bottom: 10px;
  align-items: center; 
  justify-content: center;
     
}
.left-table-container button {
  padding: 5px 15px; 
  background-color: transparent; 
  color:green; 
  border: 1px solid green; 
  border-radius: 5px; 
  cursor: pointer;
  font-weight: bold; 
  transition: background-color 0.3s, color 0.3s; 
}

.left-table-container button.active {
  background-color: green; 
  color: white; 
  outline: none; 
}

.left-table-container button:hover {
  background-color: green; 
  color: white; 
}

.left-table-container button:not(.active):not(:focus):not(:hover) {
  background-color: transparent; 
  color: green;  
}



.financial-table {
  width: 100%; 
  border-collapse: collapse;
  background-color: #fff;
  
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}


.financial-table th {
  padding: 10px;
  border: 2px solid #ddd;
}
.financial-table td {
  padding: 5px;
  border: 1px solid #a49393;  
}

.section-title {
  color: red;
  font-weight: bold;
}


.indented-item {
  padding-left: 20px;
}


.financial-table input[type="text"] {
  width: 90%;
  padding: 2px;
  box-sizing: border-box;
  border: 1px solid #ccc;
}

.financial-table input[type="text"]:focus {
  border-color: #007bff;
  outline: none;
}


#year-picker {
  font-size: 14px;
  padding: 5px;
  width: 100px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
}

#year-picker:focus {
  outline: none;
  border-color: #007bff;
  background-color: #ffffff;
}

label[for="year-picker"] {
  font-weight: bold;
  color: #333;
}

@media (max-width: 600px) {
  .dashboard-container {
    flex-direction: column; 
  }

  .left-table-container,
  .right-table-container {
    width: 100%; 
    margin-bottom: 20px;
  }
}
 
  `, "",{"version":3,"sources":["webpack://./src/components/NEW FM/Page2/Dashboard.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mCAAmC;EACnC,eAAe;;AAEjB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;;EAExB,oCAAoC;EACpC,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;;AAEzB;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;;;AAIA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;;EAEtB,wCAAwC;AAC1C;;;AAGA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;AACpB;;;AAGA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;;AAGA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,mBAAmB;EACrB;AACF","sourcesContent":["  \r\n.dashboard-container {\r\n  display: flex;\r\n  justify-content: space-between; \r\n  padding: 20px;\r\n  border:2px solid rgb(184, 174, 174);\r\n  margin-top:25px;\r\n\r\n}\r\n\r\n\r\n.left-table-container {\r\n  display: flex;            \r\n  flex-direction: column;   \r\n  margin: 3px 8px 5px 20px;   \r\n\r\n  border: 1px solid rgb(190, 185, 185);  \r\n  padding: 20px; \r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);      \r\n}\r\n\r\n.left-table-container .button-container {\r\n  display: flex;            \r\n  flex-direction: row;      \r\n  gap: 20px;                \r\n  margin-bottom: 10px;\r\n  align-items: center; \r\n  justify-content: center;\r\n     \r\n}\r\n.left-table-container button {\r\n  padding: 5px 15px; \r\n  background-color: transparent; \r\n  color:green; \r\n  border: 1px solid green; \r\n  border-radius: 5px; \r\n  cursor: pointer;\r\n  font-weight: bold; \r\n  transition: background-color 0.3s, color 0.3s; \r\n}\r\n\r\n.left-table-container button.active {\r\n  background-color: green; \r\n  color: white; \r\n  outline: none; \r\n}\r\n\r\n.left-table-container button:hover {\r\n  background-color: green; \r\n  color: white; \r\n}\r\n\r\n.left-table-container button:not(.active):not(:focus):not(:hover) {\r\n  background-color: transparent; \r\n  color: green;  \r\n}\r\n\r\n\r\n\r\n.financial-table {\r\n  width: 100%; \r\n  border-collapse: collapse;\r\n  background-color: #fff;\r\n  \r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n\r\n.financial-table th {\r\n  padding: 10px;\r\n  border: 2px solid #ddd;\r\n}\r\n.financial-table td {\r\n  padding: 5px;\r\n  border: 1px solid #a49393;  \r\n}\r\n\r\n.section-title {\r\n  color: red;\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n.indented-item {\r\n  padding-left: 20px;\r\n}\r\n\r\n\r\n.financial-table input[type=\"text\"] {\r\n  width: 90%;\r\n  padding: 2px;\r\n  box-sizing: border-box;\r\n  border: 1px solid #ccc;\r\n}\r\n\r\n.financial-table input[type=\"text\"]:focus {\r\n  border-color: #007bff;\r\n  outline: none;\r\n}\r\n\r\n\r\n#year-picker {\r\n  font-size: 14px;\r\n  padding: 5px;\r\n  width: 100px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n#year-picker:focus {\r\n  outline: none;\r\n  border-color: #007bff;\r\n  background-color: #ffffff;\r\n}\r\n\r\nlabel[for=\"year-picker\"] {\r\n  font-weight: bold;\r\n  color: #333;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .dashboard-container {\r\n    flex-direction: column; \r\n  }\r\n\r\n  .left-table-container,\r\n  .right-table-container {\r\n    width: 100%; \r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n \r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
